import { useEffect, useState } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import PropTypes from "prop-types";
import axios from "axios";
import { base_url } from "../../../config";
import ShareModal from "../../shared/shareModal/ShareModal";
import BookingConfirmPage from "../../pages/bookingConfirmPage";

dayjs.extend(customParseFormat);
const TableCard = ({ table, onBook,status, setStatus }) => {
   // null | 'paid' | 'unpaid' | 'none'
  const [orderId, setOrderId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [showCancellation, setShowCancellation] = useState(false);
  const [cancellationAvailable, setCancellationAvailable] = useState(isCancellationAvailable(table?.event_date));

  function parseEventDate(dateStr) {
    const [datePart, timePart] = dateStr?.split(' ');
    const [day, month, year] = datePart?.split('-')?.map(Number);
    const [hour, minute] = timePart?.split(':')?.map(Number);
    return new Date(year, month - 1, day, hour, minute);
  }

  function isCancellationAvailable(eventDateStr) {
    const eventDate = parseEventDate(eventDateStr);
    const now = new Date();
    const diffInMs = eventDate.getTime() - now.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60);
    return diffInHours > 24;
  }
  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      try {
        const accessToken = localStorage.getItem("@user");
        const response = await axios.get(`${base_url}/tables/view`, {
          params: { id: table.id },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        const details = response?.data?.details;
        if (!mounted) return;

        // checkId logic: booking_status 9 or 10 => booked
        if (details?.booking_status === 9 || details?.booking_status === 10) {
          setStatus("paid");
         
          return;
        }

        // checkPaidId logic: booking_status not null and not 9/10 => payment exists (treat as unpaid/needs completion)
        if (details?.booking_status !== null && details?.booking_status !== undefined) {
          if (details?.booking_status !== 9 && details?.booking_status !== 10) {
            setStatus("unpaid");
            setOrderId(details?.order_id || null);
            return;
          }
        }

        setStatus("none");
      } catch (err) {
        console.error("Error fetching table view for booking status:", err);
        if (mounted) setStatus("none");
      }
    };

    fetchData();
    return () => { mounted = false; };
  }, [table.id]);
  return (
    <div className="mt-6 border border-gray-200 -mt-10 rounded-2xl shadow-sm overflow-hidden">
      <h3 className="text-2xl font-semibold text-gray-800 px-6 pt-4">{table.title}</h3>
      <div className="p-6 bg-white">
        <img
          src={`https://s3.ap-south-1.amazonaws.com/high-table-2024/public/photo/tables/hd/${table.media}`}
          alt={table.title}
          className="w-full h-72 object-cover rounded-2xl mb-4"
        />
        <span className="text-sm px-3 py-1 bg-green-100 text-green-700 rounded-full">{table.tags || "Active"}</span>
        <div>
          <p className="text-gray-500 text-lg font-semibold mt-5 ">Price</p>
          <p className="text-lg font-medium mb-3 text-black">₹ {table.price} per seat</p>
        </div>
        <p className="text-gray-500 text-lg font-semibold mt-5 ">About Table</p>
        <p className="text-lg font-medium mb-3 text-black" dangerouslySetInnerHTML={{ __html: table.description }}></p>
        <p className="text-gray-500 text-lg font-semibold mt-1">Date & Location</p>
        {/* <p className="text-lg font-medium mb-3 text-black">{table.city},Bangalore,India</p> */}
  <p className="text-lg font-medium mb-3 text-black">{
    (() => {
      // Try parsing with known format first
      let d = dayjs(table.event_date, "DD-MM-YYYY HH:mm", true);
      if (!d.isValid()) {
        // Try parsing as ISO or fallback
        d = dayjs(table.event_date);
      }
      return d.isValid() ? d.format("MMM DD, h:mm A") : table.event_date;
    })()
  }</p>
        <p className="text-lg font-medium mb-3 text-black">{table.no_host_area},Bangalore,India</p>
        {status === 'paid' && (
          <span className="inline-block px-3 py-2 bg-green-200 text-green-800 rounded-md text-sm font-semibold mb-3">Paid</span>
        )}
        {status === 'unpaid' && (
          <span className="inline-block px-3 py-2 bg-yellow-100 text-yellow-800 rounded-md text-sm font-semibold mb-3">Pending Payment</span>
        )}
        {
            status === 'paid'?
             <button
             onClick={()=>setIsModalOpen(true)}
          className={`sm:-mt-20 px-6 py-4 text-lg font-semibold sm:justify-end sm:ml-auto flex rounded-xl bg-[#e6b800]`}
        >
         View Ticket
        </button>
        : <button
          onClick={() => onBook && onBook(table)}
          className={`sm:-mt-20 px-6 py-4 text-lg font-semibold sm:justify-end sm:ml-auto flex rounded-xl ${status === 'paid' ? 'bg-gray-300 text-gray-600 cursor-not-allowed' : 'bg-black text-white hover:bg-[#e6b800]'}`}
          disabled={status === 'paid'}
        >
          {status === 'unpaid' ? 'Complete Payment' : 'Book Now'}
        </button>
        }

        <button>

        </button>

        <div className="mt-6">
          <p 
            style={{
              cursor: 'pointer',
              color: 'blue',
              textDecoration: 'underline',
              marginBottom: '10px'
            }}
            onClick={() => setShowCancellation(!showCancellation)}
          >
            * Cancellation Policy click here to know more...
          </p>
          {showCancellation && (
            <div style={{
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
              backgroundColor: '#f8f9fa',
              boxShadow: '0 2px 6px rgba(37, 174, 233, 0.2)',
              padding: '16px'
            }}>
              <ul style={{ color: 'black' }}>
                <li>• Cancellations made up to 24 hours before the event: 100% refund (excluding payment transaction fee)</li>
                <li>• Cancellations made within 24 hours of the event: No refund</li>
                <li>• In case the event is cancelled by the host/venue, guests will receive a full refund (including payment transaction fee)</li>
                <li>• No-shows will not be eligible for a refund.</li>
              </ul>
            </div>
          )}
        </div>
       
      </div>
      {
        isModalOpen &&
        <div className="fixed w-full bg-black/40 z-[999] inset-0">

        <BookingConfirmPage
            data={table}
            closeModal={()=>setIsModalOpen(false)}
            userDetails={table?.user_profile}
            setIsShareModalOpen={setIsShareModalOpen}
          />
       </div>  
      }
      <ShareModal
            data={table}
            setIsModalOpen={setIsShareModalOpen}
            isShareModalOpen={isShareModalOpen}
          />
    </div>
  );
};

TableCard.propTypes = {
  table: PropTypes.object.isRequired,
  onBook: PropTypes.func,
};

export default TableCard;
